import TextField from '@/components/skeletons/TextField'
import InfoIcons from '@/icons/InfoIcons'
import { formatNumeral } from '@/utils/function'
import { useTranslation } from 'react-i18next'
import { Tooltip, Typogaphy } from 'vnetwork-ui'

interface BoxStatisticalProps {
    label: string
    count?: number
    helperText?: string
    children: React.ReactNode
    loading?: boolean
}

const BoxStatistical: React.FC<BoxStatisticalProps> = ({
    children,
    label,
    helperText,
    loading,
    count,
}) => {
    const { t } = useTranslation()

    return (
        <div className="bg-gray-f8 p-4 rounded-[8px]">
            <div className="flex items-center gap-2 text-gray-500">
                <Typogaphy
                    size="small"
                    className="flex items-center gap-1 capitalize"
                >
                    {t(label)}
                    {count && (
                        <span className="text-black font-medium">
                            {t('invoices.statistical.count', {
                                total: formatNumeral(count || 0, 0),
                            })}
                        </span>
                    )}
                </Typogaphy>
                {helperText && (
                    <Tooltip title={t(helperText)}>
                        <InfoIcons className="icon-small cursor-pointer" />
                    </Tooltip>
                )}
            </div>
            <Typogaphy size="large" className="font-semibold mt-2">
                {loading ? <TextField /> : children}
            </Typogaphy>
        </div>
    )
}

export default BoxStatistical
